import { render, staticRenderFns } from "./ContentCU.vue?vue&type=template&id=3d83af0c"
import script from "./ContentCU.vue?vue&type=script&lang=js"
export * from "./ContentCU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports